// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"textEditor_rootContainer__1N7ul"};